import { render, staticRenderFns } from "./ClarificationsImpugnationsWrapper.vue?vue&type=template&id=8b9b89a4&"
import script from "./ClarificationsImpugnationsWrapper.vue?vue&type=script&lang=js&"
export * from "./ClarificationsImpugnationsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports